import { render, staticRenderFns } from "./examinePropertyRightRegistration.vue?vue&type=template&id=2231a786&scoped=true"
import script from "./examinePropertyRightRegistration.vue?vue&type=script&lang=js"
export * from "./examinePropertyRightRegistration.vue?vue&type=script&lang=js"
import style0 from "./examinePropertyRightRegistration.vue?vue&type=style&index=0&id=2231a786&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/.pnpm/vue-loader@15.11.1_@vue+com_a6c7c6c484daeff6636bea47b922569f/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2231a786",
  null
  
)

export default component.exports